
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import activityTypeService from '../services/activityTypeService';

const activityTypesCollectionName = "activity_types";

export const useActivityType = () => {
  return useQuery({
    queryKey: [activityTypesCollectionName],
    queryFn: () => activityTypeService.getAll(),
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export const useAddActivityType = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: activityTypeService.add,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [activityTypesCollectionName] });
    },
  });
};

export const useEditActivityType = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: activityTypeService.edit,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [activityTypesCollectionName] });
    },
  });
};

export const useDeleteActivityType = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: activityTypeService.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [activityTypesCollectionName] });
    },
  });
};

export const useActivityTypeNameById = (activityTypeId) => {
  return useQuery({
    queryKey: [activityTypesCollectionName, activityTypeId],
    queryFn: () => activityTypeService.getNameById(activityTypeId),
    enabled: !!activityTypeId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export const useSpendTypeActivityTypes = (spendTypeId) => {
  return useQuery({
    queryKey: [activityTypesCollectionName, spendTypeId],
    queryFn: () => activityTypeService.getSpendTypeActivityTypes(spendTypeId),
    enabled: !!spendTypeId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};